import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Button = ({ buttonText, buttonType, href, onClick }) => {
  return (
    <div className="text-center">
      <Link
        to={href || "#"}
        onClick={onClick}
        className={`${
          buttonType === "nav" ? "mega-cta-nav" : "mega-cta"
        } text-decoration-none`}
      >
        {buttonText}
      </Link>
    </div>
  );
};

export default Button;
